var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flag == _vm.index && _vm.detailShow
    ? _c("div", { staticClass: "sync-detail" }, [
        _c("div", { staticClass: "sync-title" }, [
          _vm._v(
            "\r\n        " +
              _vm._s(_vm.$t("language.common.syncDetails")) +
              "\r\n    "
          )
        ]),
        _vm._v(" "),
        _vm.itemSyncDetail.syncDetail &&
        _vm.itemSyncDetail.syncDetail.runningStatus == 1
          ? _c("div", { staticClass: "detail-sync-count" }, [
              _c("div", { staticClass: "sync-line" }, [
                _vm._v(
                  _vm._s(_vm.$t("language.common.countFiles")) +
                    ":(" +
                    _vm._s(_vm.itemSyncDetail.syncDetail.readyFindFileCount) +
                    _vm._s(_vm.$t("language.common.transferFiles")) +
                    "," +
                    _vm._s(
                      _vm._f("formatByte")(
                        _vm.itemSyncDetail.syncDetail.totalBytes
                      )
                    ) +
                    ")"
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "sync-detail-one" }, [
          _c("div", { staticClass: "sync-line" }, [
            _c("div", { staticStyle: { float: "left" } }, [
              _vm._v(_vm._s(_vm.$t("language.common.sync")) + ":")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "catelog-color catelog-style catelog-width",
                attrs: {
                  title: _vm._f("getCatalogTitle")(
                    _vm._f("getCatalog")(_vm.itemSyncDetail.fromItem.nodes)
                  )
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toSourceCatalog(_vm.itemSyncDetail.syncDetail)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm._f("getCatalog")(_vm.itemSyncDetail.fromItem.nodes)
                  )
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sync-line" }, [
            _c("div", { staticStyle: { float: "left" } }, [
              _vm._v(_vm._s(_vm.$t("language.common.with")) + ":")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "catelog-color catelog-style catelog-width",
                attrs: {
                  title: _vm._f("getCatalogTitle")(
                    _vm._f("getCatalog")(_vm.itemSyncDetail.toItem.nodes)
                  )
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toAimCatalog(_vm.itemSyncDetail)
                  }
                }
              },
              [
                _vm._v(
                  _vm._s(_vm._f("getCatalog")(_vm.itemSyncDetail.toItem.nodes))
                )
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sync-detail-two" }, [
          _c("div", { staticClass: "sync-all-line" }, [
            _c("span", { staticClass: "sync-column-left" }, [
              _vm._v(
                _vm._s(_vm.$t("language.common.fileProcess")) +
                  ":\r\n                "
              ),
              _vm.itemSyncDetail.syncDetail &&
              _vm.itemSyncDetail.syncDetail.runningStatus != 0 &&
              _vm.itemSyncDetail.syncDetail
                ? _c("span", [
                    _vm._v(
                      "\r\n                " +
                        _vm._s(_vm.itemSyncDetail.syncDetail.addFileCount) +
                        "/" +
                        _vm._s(_vm.itemSyncDetail.syncDetail.readyFindFileCount)
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sync-line" }, [
            _c("span", { staticClass: "sync-column-left" }, [
              _vm._v(
                _vm._s(_vm.$t("language.common.dataProcess")) +
                  ":\r\n                "
              ),
              _vm.itemSyncDetail.syncDetail &&
              _vm.itemSyncDetail.syncDetail.runningStatus != 0 &&
              _vm.itemSyncDetail.syncDetail
                ? _c("span", [
                    _vm._v(
                      "\r\n                " +
                        _vm._s(
                          _vm._f("formatByte")(
                            _vm.itemSyncDetail.syncDetail.readedBytes
                          )
                        ) +
                        "/" +
                        _vm._s(
                          _vm._f("formatByte")(
                            _vm.itemSyncDetail.syncDetail.totalBytes
                          )
                        )
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sync-column-right" }, [
              _vm._v(
                _vm._s(_vm.$t("language.popup.progress")) +
                  ":\r\n                "
              ),
              _vm.itemSyncDetail.syncDetail &&
              _vm.itemSyncDetail.syncDetail.runningStatus > 1
                ? _c("span", [
                    _vm.itemSyncDetail.syncDetail.percent
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.itemSyncDetail.syncDetail.percent + "%"
                              )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.itemSyncDetail.syncDetail.percent
                      ? _c("span", [_vm._v("0%")])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sync-line" }, [
            _c("span", { staticClass: "sync-column-left" }, [
              _vm._v(_vm._s(_vm.$t("language.common.startTime")) + ":"),
              _vm.itemSyncDetail.syncDetail &&
              _vm.itemSyncDetail.syncDetail.runningStatus != 0
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("transferTime")(
                          _vm.itemSyncDetail.syncDetail.taskStartTimeLong
                        )
                      ) + " "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sync-column-right" }, [
              _vm._v(_vm._s(_vm.$t("language.common.currentRate")) + ": "),
              _vm.itemSyncDetail.syncDetail &&
              _vm.itemSyncDetail.syncDetail.runningStatus > 1
                ? _c("span", [
                    _vm._v(_vm._s(_vm.itemSyncDetail.syncDetail.speed))
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-508e4742", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508e4742","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_sync_detail.vue
// module id = null
// module chunks = 